import Button from "@visa/vds/button";
import Icon from "@visa/vds/icon";
import Listbox from "@visa/vds/listbox";
import ListboxItem from "@visa/vds/listbox-item";
import ListboxItemContainer from "@visa/vds/listbox-item-container";
import NavMenu from "@visa/vds/navmenu";
import Tab from "@visa/vds/tab";
import TabItem from "@visa/vds/tab-item";
import lodash from "lodash";
import React from "react";
import { useHistory } from "react-router-dom";

const MCSDesktopNavItem = (props) => {
  const history = useHistory();
  const navDropdownId = "nav-dropdown-";
  let tabItemClassName = "";
  if (props.item.alwaysVisible) {
    tabItemClassName = "vss-tab-item-visible";
  } else if (props.item.adminMenu) {
    tabItemClassName = "vss-tab-item-admin-menu";
  }

  const handleRouting = (dir, tabSelected) => {
    history.push(dir);
    props.setSelectedTab(tabSelected);
  };

  const handleRoutingWithDropdown = (dir, key) => {
    document.getElementById(navDropdownId + key).click(); // Hide nav dropdown menu on click child menu
    history.push(dir);
    props.setSelectedTab(props.item.menuLabel);
  };

  const renderMenuLabel = () => {
    return (
      <>
        {props.item.menuIcon && props.item.menuIcon}
        {(props.item.useLabel ?? true) && props.item.menuLabel}
      </>
    );
  };

  if (
    lodash.isNil(props.availableChild) || props.availableChild.length === 0
  ) {
    return (
      <TabItem className={tabItemClassName}>
        <Tab
          selected={props.selectedTab === props.item.menuLabel}
          onClick={() =>
            handleRouting(props.item.redirect, props.item.menuLabel)
          }
          role={undefined}
        >
          {renderMenuLabel()}
        </Tab>
      </TabItem>
    );
  } else {
    return (
      <TabItem className={tabItemClassName}>
        <NavMenu
          id={navDropdownId + props.k}
          className="dropdown-menu"
          menu={
            <Listbox className="menu-box">
              {props.availableChild &&
                props.availableChild.map(
                  (child, k) =>
                    (
                      <ListboxItem
                        key={k}
                        k={k}
                        role="none"
                        selected={props.selectedTab === child.menuLabel}
                      >
                        <ListboxItemContainer>
                          <a
                            onClick={() =>
                              handleRoutingWithDropdown(child.redirect, props.k)
                            }
                          >
                            {child.menuLabel}
                          </a>
                        </ListboxItemContainer>
                      </ListboxItem>
                    )
                )}
            </Listbox>
          }
          placement="bottom-start"
          role="navigation"
          tag="nav"
        >
          <Button
            flippable
            className={
              "vds-tab " +
              (props.selectedTab === props.item.menuLabel
                ? "vds-state--selected"
                : "")
            }
          >
            <div className="dropdown-menu-text">{renderMenuLabel()}</div>
            <Icon name="arrow-expand" resolution="tiny" />
          </Button>
        </NavMenu>
      </TabItem>
    );
  }
};

export default MCSDesktopNavItem;
